<template>
  <div class="bid-report" v-if="bidStatus === 'off'">
    <b-card :footer="bid | currency" footer-tag="footer" title="Subastado">
      <b-card-text v-if="bid >= minimum && loggedInMembership === bidAffiliate">
        Afiliado no. {{ loggedInMembership }}
        <br />
        <div class="trophy" :class="status | variant">
          <font-awesome-icon icon="trophy" class="fa-3x" />
        </div>
      </b-card-text>
      <b-badge class="p-3" :variant="status | variant">{{status | textual}}</b-badge>
    </b-card>
  </div>
</template>

<script>
import utils from "../../assets/js/utils";
import { library } from "@fortawesome/fontawesome-svg-core";
import { faTrophy } from "@fortawesome/free-solid-svg-icons";
library.add(faTrophy);
export default {
  name: "BidReport",
  props: {
    id: {
      type: String
    },
    code: {
      type: String
    },
    bidStatus: {
      type: String
    },
    bidAffiliate: {
      type: Number,
      required: false,
      default: 0
    },
    bid: {
      type: Number,
      required: false,
      default: 0
    },
    minimum: {
      type: Number
    },
    base: {
      type: Number
    }
  },
  computed: {
    status: function() {
      if (this.bidAffiliate === 0 || this.bid < this.minimum) {
        return 0;
      }

      if (this.bid < this.base) {
        return 1;
      }

      return 2;
    },
    loggedInMembership: function() {
      return this.$store.getters.loggedInMembership;
    }
  },
  filters: {
    currency: function(value) {
      if (value === 0) {
        return "Sin ofertas";
      }
      return utils.formatCurrency(value);
    },
    textual: function(status) {
      switch (status) {
        case 0:
          return "No adjudicado";
        case 1:
          return "Sujeto a aprobación";
      }
      return "Adjudicado";
    },
    variant: function(status) {
      switch (status) {
        case 0:
          return "danger";
        case 1:
          return "warning";
      }
      return "success";
    }
  }
};
</script>

<style lang="scss" scoped>
@import "../../assets/scss/partial";

.bid-report {
  text-align: center;
}

.card-title {
  font-size: 1.2rem;
}

.badge {
  white-space: normal;
  font-size: 0.8rem;
}

.trophy {
  color: $green;

  &.warning {
    color: $yellow;
  }
}

@media (min-width: viewport-min-size("lg")) and (max-width: prev-viewport-max-size("xl")) {
  .card-title {
    font-size: 1rem;
  }
}

@media (min-width: viewport-min-size("md")) and (max-width: prev-viewport-max-size("lg")) {
  .card-body {
    padding: 0.8rem;
  }

  .card-title {
    font-size: 0.7rem;
  }

  .badge {
    font-size: 0.6rem;
  }

  .card-footer {
    font-size: 0.9rem;
    padding: 0.75rem;
  }
}
</style>
